import React, { useEffect } from 'react';
import authProvider, { POST_SIGNIN_REDIRECT_KEY } from '../authProvider';
import { isCommonsModeEnabled } from '../featureToggles';

const useSetupAuthProvider = (store) => {
  const [isSetup, setIsSetup] = React.useState(false);
  if (!isSetup) {
    const provider = authProvider();
    provider.registerStore(store);
    provider.initializeUserManager();
    setIsSetup(true);
  }
};

const STATE_ERRORS = ['No state in response', 'No matching state found in storage'];

const redirectToRoute = () => {
  window.location.replace(sessionStorage.getItem(POST_SIGNIN_REDIRECT_KEY) || '/#/');
};

const useSignInCallback = () => {
  useEffect(() => {
    authProvider().getUserManager().signinCallback()
      .then((user) => {
        // maybe update state to authenticated here
        let redirect = '#';
        if (user && user.state) {
          redirect = user.state.post_signin_redirect_uri;
        }
        window.location.replace(redirect);
      })
      .catch(async (error) => {
        const isSignedIn = !!(await authProvider().getAccount());

        if (isSignedIn) {
          redirectToRoute();
          return undefined;
        }

        window.console.error(error);

        if (!STATE_ERRORS.some((msg) => error.message.includes(msg))) {
          return undefined;
        }

        if (error.message.includes('No state in response') && !isCommonsModeEnabled()) {
          return authProvider().authenticate();
        }

        redirectToRoute();
        return undefined;
      });
  }, []);
};

export default {
  useSetupAuthProvider,
  useSignInCallback,
};
